import { render, staticRenderFns } from "./Anthology.vue?vue&type=template&id=0009ea2b&"
import script from "./Anthology.vue?vue&type=script&lang=js&"
export * from "./Anthology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports